<script>
import TableroHeader from "@/components/Lego/TableroHeader.vue";
import TableroKanban from "@/components/Lego/TableroKanban.vue";
import TableroGantt from "@/components/Lego/TableroGantt.vue";
import TourGuideLineal from "@/components/helexium/TourGuideLineal.vue";
export default {
  props: {
    boardId: {
      required: true,
    },
    personaId: {
      required: true,
    },
  },
  components: {
    TableroHeader,
    TableroKanban,
    TableroGantt,
    TourGuideLineal,
  },
  data() {
    return {
      isReady: false,
      typesOfBoard: [
        { name: "Kanban", value: "TableroKanban" },
        { name: "Gantt", value: "TableroGantt" },
      ],
      selectedType: "Kanban",
    };
  },
  async mounted() {
    console.log("boardId", this.boardId, "personaId", this.personaId);

    this.$store.commit("lego/setSkeleton", true);
    this.isReady = true;

    // Cargar datos del tablero
    await this.$store.dispatch("lego/getAndSetBoardDeep", {
      boardId: this.boardId,
      personaId: this.personaId,
    });
  },
  beforeDestroy() {
    this.$store.dispatch("lego/cleanBoard");
    this.$store.commit("lego/setShowAllTasks", false); // Actualizar el estado en el store
  },
  computed: {
    typeOfBoard() {
      return this.typesOfBoard.find((type) => type.name === this.selectedType)
        .value;
    },
    roleLevel() {
      if (!this.isReady) return null;
      return this.$store.state.lego.currencyRole.level;
    },
    tourSteps() {
      if (!this.isReady) return null;
      const steps = [];
      steps.push(
        {
          title: "Tablero Kanban",
          description:
            "Kanban es un sistema de gestión de flujos de trabajo que se basa en la visualización del trabajo en progreso, limitando el trabajo en curso y enfocándose en mejorar continuamente el proceso. Se implementa a través de tableros visuales, donde las tareas se representan con tarjetas que avanzan a través de diferentes columnas que representan las etapas del proceso, es una de las dos maneras qué se tienen en Helexium para visualizar la información de los tableros.",
          elementId: "tipoTablero0",
        },
        {
          title: "Tablero Gantt",
          description:
            "Un diagrama de Gantt es una herramienta de gestión de proyectos que visualiza las tareas de un proyecto y sus cronogramas a lo largo del tiempo. Se utiliza para planificar, coordinar y realizar un seguimiento del progreso de un proyecto, es la otra manera que se tiene para visualizar la información de tus tableros en Helexium.",
          elementId: "tipoTablero1",
        }
      );
      if (this.roleLevel < 3) {
        steps.push({
          title: "Opciones Tablero",
          description:
            "En este apartado podrás agregar nuevos colabores además de poder modificarles el rol, Editar el nombre del tablero, hacer una copia y crear una plantilla.",
          elementId: "opcionesTableroLegos",
        });
      } else {
        steps.push({
          title: "Opciones Tablero",
          description: "Mostrar todas las tareas asignadas",
          elementId: "opcionesTableroLegos",
        });
      }
      steps.push(
        {
          title: "Progreso actividades",
          description:
            "En este apartado podrás visualizar el progreso de todas las actividades en general.",
          elementId: "barraProgresoTablero",
        },
        {
          title: "Buscador",
          description:
            "En este apartado podrás ingresar el nombre del a columna, tareas o información relacionada a los tableros para poder filtrarlos mucho mas rápido.",
          elementId: "buscadorColumnasTablero",
        },
        {
          title: "Tareas del tablero",
          description:
            "En este apartado encontrarás todas las columnas relacionadas al tablero con sus actividades correspondientes.",
          elementId: "tablerosKanban",
        },
        {
          title: "Encabezado del Tablero",
          description:
            "En este apartado podrás modificar el nombre de la columna siempre y cuando seas el propietario del tablero.",
          elementId: "headerTablero0",
        },
        {
          title: "Progreso tablero",
          description:
            "Barra de progreso en base a las actividades de la columna que se está visualizando.",
          elementId: "progresoTareaTablero0",
        },
        {
          title: "Crear Tarjeta",
          description:
            "En este apartado podremos crear nuevas tarjetas, las cuales son correspondientes a las tareas de los colaboradores.",
          elementId: "crearTarjeta0",
        },
        {
          title: "Tarjeta",
          description:
            "Una vez creadas las tarjetas, tendremos opciones de agregar sub tareas, listas de checkeo y muchas mas opciones, para más información visualiza el tutorial sobre tarjetas dando click en alguna de estas.",
          elementId: "cardInColumn0",
        }
      );

      return steps;
    },
  },
  methods: {
    startTour() {
      this.$refs.tourGuide.startTour(this.tourSteps);
    },
  },
};
</script>

<template>
  <div class="wrapper">
    <TourGuideLineal v-if="isReady" ref="tourGuide" />
    <Router-view />
    <TableroHeader v-if="isReady" class="header" :boardId="boardId">
      <div class="typesBoards flex-wrap flex-md-nowrap">
        <vs-button
          id="startButton"
          v-b-tooltip.hover
          title="Iniciar tutorial"
          circle
          icon
          danger
          relief
          @click.prevent="startTour"
        >
          <i class="far fa-circle-play mr-1"></i>
          Tutorial
        </vs-button>

        <vs-button
          border
          v-for="(typeOfBoard, index) in typesOfBoard"
          :active="typeOfBoard.name == selectedType"
          :key="typeOfBoard.value"
          @click="selectedType = typeOfBoard.name"
          :id="'tipoTablero' + index"
        >
          <i
            :class="`${
              typeOfBoard.name == 'Kanban'
                ? 'fab fa-trello'
                : 'fas fa-chart-gantt'
            } mr-2`"
            style="font-size: 1rem"
          ></i>
          {{ typeOfBoard.name }}
        </vs-button>
      </div>
    </TableroHeader>
    <div class="container-board">
      <component :is="typeOfBoard" />
    </div>
  </div>
</template>

<style scoped>
.wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.typesBoards {
  display: flex;
  align-items: center;
  justify-content: center;

  & button {
    width: 8rem;
  }
}

.container-board {
  flex: auto;
  height: 70vh;
}

@media (min-width: 1500px) and (max-width: 2000px) {
  .container-board {
    height: 80dvh;
  }
}
@media (min-width: 2000px) {
  .container-board {
    height: 90dvh;
  }
}
</style>
